export { default } from './InformasiBesaranSubsidi';
